<template>
    <InfoModal v-model:open="open" title="Help Nadia learn what matters most to you" :sections="sections" />
</template>

<script setup lang="ts">
import InfoModal, { type InfoModalSection } from "./InfoModal.vue";

const open = defineModel<boolean>("open", { default: false });

const sections: InfoModalSection[] = [
    {
        icon: "bi-chat-dots",
        title: "Richer coaching",
        description: "Priority goals are woven into every coaching conversation",
    },
    {
        icon: "bi-bullseye",
        title: "Better suggestions in the future",
        description: "Knowing which goals you're focused on leads to more effective suggestions in the future",
    },
    {
        icon: "bi-lightbulb",
        title: "Coming soon: Insights",
        description: "Nadia will produce insights that make the biggest impact in your development arc",
    },
];
</script>
